<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#">
          <i class="fas fa-bars"></i>
        </a>
      </li>
      <li class="nav-item">
         <div class="inline-volume-controls d-inline-flex align-items-center ml-1">
          <button @click="$eventHub.$emit('player_toggle');" class="btn btn-sm nav-link">
          <i class="fas fa-2x text-info" :class="this.$store.state.isPlaying ?'fa-stop-circle': 'fa-play-circle'"></i>
        </button>
          <div v-if="this.$store.state.isPlaying" class="flex-fill mx-1">
            <input
              type="range"
              title="Volume"
              v-model="volume"
              min="0"
              max="100"
              step="1"
              class="player-volume-range custom-range"
            />
          </div>
        </div>
      </li>
       <li v-if="getAyoba()" class="nav-item">
        <a  @click.prevent="startChat" target="_blank" class="nav-link" href="https://wa.me/233243270000?text=Hello">
          <img class="mr-2" src="@/assets/ayoba_logo.png" width="20" height="auto" alt="">
        </a>
      </li>
      <li v-else class="nav-item">
        <a target="_blank" class="nav-link" href="https://wa.me/233243270000?text=Hello">
          <i class="fab fa-2x fa-whatsapp text-success"></i>
        </a>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
    
      <li class="nav-item">
        <a @click="logout" class="nav-link" href="#">Logout</a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script type="text/ecmascript-6">

import {  CLEAR_AUTH_INFO } from "@/store/mutation-types";

export default {

  methods: {
    
     logout() {
     this.$store.commit(CLEAR_AUTH_INFO)
        this.$router.go('/login')
    },


  },


};
</script>

<style scoped>
.fa-2x {
  font-size: 1.5em;
}

.dropdown-menu-right {
  left: -80px;
}
</style>